import React from 'react';
import { motion } from 'framer-motion';
export function Chapters() {
  const chapters = ['El origen del despertar', 'El budismo explicado con sencillez', 'El budismo en tu día a día', 'Budismo y ciencia en 2026', 'Vivir el budismo en la era digital', 'Los desafíos del budismo moderno', 'El arte de transformar tu vida con budismo'];
  return <section id="contenido" className="py-24 bg-[#112240]" data-id="element-12">
      <div className="max-w-4xl mx-auto px-6 md:px-12" data-id="element-13">
        <div className="text-center mb-16" data-id="element-14">
          <span className="text-[#D4AF37] font-['Inter'] font-semibold tracking-[0.2em] text-sm mb-4 block uppercase" data-id="element-15">
            Contenido
          </span>
          <h2 className="text-4xl md:text-5xl font-['Playfair_Display'] text-[#FFF8F0]" data-id="element-16">
            ¿Qué hay dentro?
          </h2>
        </div>

        <div className="bg-[#0A192F] rounded-2xl border border-[#1D3461] p-6 md:p-12 shadow-xl" data-id="element-17">
          {chapters.map((chapter, index) => <motion.div key={index} className={`flex items-center gap-6 py-6 ${index !== chapters.length - 1 ? 'border-b border-[#1D3461]' : ''}`} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} data-id="element-18">
              <span className="text-3xl md:text-4xl font-['Playfair_Display'] text-[#D4AF37] opacity-50 w-12 text-right flex-shrink-0" data-id="element-19">
                0{index + 1}
              </span>
              <h3 className="text-lg md:text-xl font-['Inter'] text-[#FFF8F0] font-light" data-id="element-20">
                {chapter}
              </h3>
            </motion.div>)}
        </div>
      </div>
    </section>;
}